import { useHistory } from "react-router";
import { AiOutlineLogout } from "react-icons/ai";
import { useDispatch } from "react-redux";

import { IBaseBtn } from "./interfaces";
import BaseButton from "./BaseButton";
import { useState } from "react";
import { ThisPaths } from "../../shared/Constants";
import { ComponentStatus } from "..";
import { SessionService } from "../../services";
import { Actions } from "../../app-state/actions";
import { errorModal } from "../Alerts";

const LogoutBtn: React.FC<IBaseBtn> = (props) => {
    const history = useHistory();
    const [error, setError] = useState<string>("");
    const [status, setStatus] = useState<ComponentStatus>("complete");
    const dispatch = useDispatch();

    const handleAction = async () => {
        setStatus("loading");
        const sr = await SessionService.LogOut();

        if (sr.status()) {
            dispatch(Actions.RESET_STATE());
            history.replace(ThisPaths.LOGIN);
        } else {
            setStatus("errored");
            setError(sr.error);
        }
    };

    return (
        <>
            {status === "errored" && errorModal(error)}
            <BaseButton
                {...props}
                Icon={AiOutlineLogout}
                title="Salir"
                onClick={handleAction}
                style={{ borderRadius: "2vw", ...props.style }}
            />
        </>
    );
};

export default LogoutBtn;
